import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import LicenseKeyModel from '@shared/models/organizations/LicenseKeyModel';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import LicenseKeyDetails from './LicenseKeyDetails';

interface ILicenseKeyDetailsDialogProps {
    open: boolean;
    onClose: () => void;
    licenseKey: LicenseKeyModel;
}

function LicenseKeyDetailsDialog({ open, onClose, licenseKey }: Readonly<ILicenseKeyDetailsDialogProps>) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleConfirm = () => {
        onClose();
        navigate(`/org/${licenseKey.originatedByOrganizationId}/managed/${licenseKey.organizationId}`);
    };

    return (
        <ContentDialog
            fullWidth
            open={open}
            onClose={onClose}
            title={t('common:license.key.details')}
            onCancel={onClose}
            onConfirm={handleConfirm}
            confirmButtonText={t('common:organization.viewOrganization')}>
            <LicenseKeyDetails licenseKey={licenseKey} />
        </ContentDialog>
    );
}

export default LicenseKeyDetailsDialog;
